import React from 'react';

function ForgotPass(props){
  return(
    <a href={props.href} className="forgot-link">{props.title}</a>
  );
}

export default ForgotPass;